import { loadImage } from "./load-image.js";
import { inferModelType, loadCapeToCanvas, loadSkinToCanvas } from "./process.js";
// https://www.typescriptlang.org/docs/handbook/mixins.html
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name));
        });
    });
}
export function isTextureSource(value) {
    return value instanceof EventTarget || value instanceof ImageBitmap;
}
export class SkinContainer {
    loadSkin(source, model = "auto-detect", options) {
        if (source === null) {
            this.resetSkin();
        }
        else if (isTextureSource(source)) {
            loadSkinToCanvas(this.skinCanvas, source);
            const actualModel = model === "auto-detect" ? inferModelType(this.skinCanvas) : model;
            this.skinLoaded(actualModel, options);
        }
        else {
            return loadImage(source).then(image => this.loadSkin(image, model, options));
        }
    }
}
export class CapeContainer {
    loadCape(source, options) {
        if (source === null) {
            this.resetCape();
        }
        else if (isTextureSource(source)) {
            loadCapeToCanvas(this.capeCanvas, source);
            this.capeLoaded(options);
        }
        else {
            return loadImage(source).then(image => this.loadCape(image, options));
        }
    }
}
//# sourceMappingURL=viewer-mixins.js.map